module.exports = "<p>\n  taluk works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/taluk/taluk.component.html
// module id = ./src/app/masters/taluk/taluk.component.html
// module chunks = main